import { render, staticRenderFns } from "./behaviors-report.vue?vue&type=template&id=9a694898&"
import script from "./behaviors-report.vue.js?vue&type=script&lang=js&"
export * from "./behaviors-report.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports